export const BOOST_SCORE_THRESHOLD = 68;
export const KEEP_SCORE_THRESHOLD = 43;

/** User-facing fallback when a metric is unavailable (design system: not "N/A"). */
export const ANALYTICS_UNAVAILABLE_LABEL = "Nije dostupno";
